
export const EDIT = "edit";
export const CREATE = "create";
export const FORBIDDEN = "forbidden";

export const NOT_FOUND = "not_found";

export const CLEAR_ERRORS = "clear_errors";
export const BEFORE_LOAD = "before_load";
export const LOADING_ERROR = "loading_error";

export const SAVING_PROBLEMS = "saving_problems";

export const BEFORE_SAVE = "before_save";

export const REPLACE_INIT_WITH_EDIT = "replace";